export enum MappingNames {
    TreeNoH = 'tree_no_h',
    TreeWithH = 'tree_with_h',
}
